import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomHighChartComponent from "../../../../../shared/custom-highchart-component/custom-highchart.component";
import CustomSpinnerComponent from "../../../../../shared/custom-spinner/custom-spinner.component";
import { getBurnChartData } from "../../../../../store/slices/asset.slice";
import { generateFilenameWithTimestamp } from "src/shared/helpers/generateFilenameWithTimestamp";
import ChipComponent from "src/core/components/chip/chip.component";

interface AssetDetailsBurnTimeChartType {
  assetId: any;
  isRefreshed: boolean;
  assetDetails?: any;
}

const AssetDetailsBurnTimeChart: FC<AssetDetailsBurnTimeChartType> = ({
  assetId,
  isRefreshed,
  assetDetails,
}) => {
  const dispatch = useDispatch();
  const [burnTimeData, setBurnTimeData] = useState<any>({});

  useEffect(() => {
    dispatch(getBurnChartData({ id: assetId }));
  }, [assetId, isRefreshed]);

  const isLoadingBurnChartData = useSelector((state: any) => {
    return state.asset.isLoadingBurnChartData;
  });

  const burnChartData = useSelector((state: any) => {
    return state.asset.burnChartData;
  });

  useEffect(() => {
    if (burnChartData?.data?.length) {
      /*       const isEveryBurnTimeZero = burnChartData?.data?.every(
        (data: any) => data?.burnTime == 0
      ); */

      /*       if (isEveryBurnTimeZero) {
        setBurnTimeData({
          burnTime: [],
          timestamp: [],
        });
      } else { */
      // const burnTime = burnChartData?.data?.map((d: any) => d?.burnTime);
      const timestamp = burnChartData?.data?.map((d: any) => d?.timestamp);

      const burnTime = burnChartData?.data?.every(
        (d: any) => d?.burnTime == null
      )
        ? null
        : burnChartData?.data?.map((d: any) => d?.burnTime);

      setBurnTimeData({
        burnTime,
        timestamp,
      });
      // }
    } else {
      setBurnTimeData({
        burnTime: [],
        timestamp: [],
      });
    }
  }, [burnChartData]);

  const burnTimeChartToolTipFormatter = (point: any) => {
    const { x, y } = point;

    const time = burnTimeData?.timestamp?.[point.index] || point.category || x;
    return `<b>Time (Date): </b> ${time}<br/>
            <b>Burn Time (hours): </b> ${y} <br/>`;
  };

  return (
    <div className="mt-4 ">
      <div>
        <h4 className="h4" style={{ marginBottom: "1rem" }}>
          Burn Time <span style={{ fontSize: "16px" }}>(Last 7 Days){assetDetails?.vendor == "ST Engineering" && <ChipComponent label="Estimated" />}</span>
        </h4>
      </div>

      <CustomSpinnerComponent
        height={"300px"}
        width={"100%"}
        isLoading={isLoadingBurnChartData}
      >
        <CustomHighChartComponent
          xAxisCategories={burnTimeData?.timestamp}
          SeriesType={"line"}
          seriesData={burnTimeData?.burnTime}
          seriesShowInLegend={false}
          seriesName={"Burn Time(hours)"}
          xAxisTitleText={"Time (Date)"}
          yAxisTitleText={"Burn Time(hours)"}
          colors={["#66b2ff"]}
          containerProps={{
            style: { height: "350x", marginLeft: "-1rem" },
          }}
          fileName={generateFilenameWithTimestamp("Burn Time (Last 7 Days)")}
          chartName={"Burn Time (Last 7 Days)"}
          tooltipFormatter={burnTimeChartToolTipFormatter}
        />
      </CustomSpinnerComponent>
    </div>
  );
};

export default AssetDetailsBurnTimeChart;
